import { BaseCommand } from './baseCommand';
import Element, { SpecyficType } from '../element';
import store from '@/store';
import { Vector2, Mesh } from '@babylonjs/core';
import { Product, ProductType } from '@/store/modules/product';

export class HandleBacksCommand extends BaseCommand {

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public execute() {
        const product: Product = store.getters.product;
        if (product.type !== ProductType.CHEST_FURNITURE) { return; }
        const body: Element = store.getters.body;
        const verticalWalls = this.getVerticalWalls(body);
        const tapeMeshes = this.getTapeMeshes(body);
        const tapes = this.getTapes(body);
        const backs = this.createBacks(
            body,
            verticalWalls,
            tapeMeshes,
        );
        this.handleTapesVisibility(
            backs,
            tapes,
            tapeMeshes,
        );
        store.commit('setBacks', backs);
    }

    public revert() {
        this.execute();
    }

    private getVerticalWalls(body: Element): Element[] {
        return store.getters.scene.elements
            .filter((x: Element) =>
                x.specyficType === SpecyficType.VERTICAL_WALL &&
                x.shape.y >= 2 &&
                x.shape.y === body.shape.y,
            );
    }

    private getTapeMeshes(body: Element): Mesh[] {
        return body.meshes.filter((x) => x.name.includes('tasma'));
    }

    private getTapes(body: Element) {
        const y = 0.5 + body.shape.y / 2;
        return body.shape.x === 4 ? [
            { name: 'AB', x: 3.5, y },
            { name: 'BC', x: 2.5, y },
            { name: 'CD', x: 1.5, y },
        ] : body.shape.x === 3 ? [
            { name: 'AB', x: 2.5, y },
            { name: 'BC', x: 1.5, y },
        ] : body.shape.x === 2 ? [
            { name: '', x: 1.5, y },
        ] : [];
    }

    private createBacks(
        body: Element,
        verticalWalls: Element[],
        tapeMeshes: Mesh[],
    ): Element[] {
        const backs: Element[] = [];
        if (
            tapeMeshes.length === 0 ||
            body.shape.x <= 2 ||
            body.shape.y <= 1
        ) {
            const back = this.createSingleBack(body);
            backs.push(back);
        } else {
            backs.push(...this.createMultipleBacks(
                body,
                verticalWalls,
            ));
        }
        return backs;
    }

    private createSingleBack(body: Element) {
        return new Element('back', '', '',
            body.position,
            body.shape,
            []);
    }

    private createMultipleBacks(
        body: Element,
        verticalWalls: Element[]
    ) {
        const y = 0.5 + body.shape.y / 2;
        if (body.shape.x === 3) {
            if (verticalWalls.some((wall) => wall.position.x === 1.5)) {
                return [
                    new Element('back', '', '', new Vector2(1, y), new Vector2(1, body.shape.y), []),
                    new Element('back', '', '', new Vector2(2.5, y), new Vector2(2, body.shape.y), []),
                ];
            } else {
                return [
                    new Element('back', '', '', new Vector2(1.5, y), new Vector2(2, body.shape.y), []),
                    new Element('back', '', '', new Vector2(3, y), new Vector2(1, body.shape.y), []),
                ];
            }
        }
        if (body.shape.x === 4) {
            if (
                verticalWalls.length === 0 ||
                verticalWalls.some((wall) => wall.position.x === 2.5)
            ) {
                return [
                    new Element('back', '', '', new Vector2(1.5, y), new Vector2(2, body.shape.y), []),
                    new Element('back', '', '', new Vector2(3.5, y), new Vector2(2, body.shape.y), []),
                ];
            } else {
                return [
                    new Element('back', '', '', new Vector2(1, y), new Vector2(1, body.shape.y), []),
                    new Element('back', '', '', new Vector2(2.5, y), new Vector2(2, body.shape.y), []),
                    new Element('back', '', '', new Vector2(4, y), new Vector2(1, body.shape.y), []),
                ];
            }
        }
        return [];
    }

    private createMultipleBacks_old(
        body: Element,
        verticalWalls: Element[]) {
        const backs: Element[] = [];
        let prev = 0.5;
        for (let i = 1.5; i <= body.shape.x + 0.5; i++) {
            if (i === body.shape.x + 0.5 || verticalWalls.some((x) => x.position.x === i)) {
                const element = new Element('back', '', '',
                    new Vector2(prev + (i - prev) / 2, 0.5 + body.shape.y / 2),
                    new Vector2(i - prev, body.shape.y),
                    [],
                )
                backs.push(element);
                prev = i;
            }
        }
        return backs;
    }

    private handleTapesVisibility(
        backs: Element[],
        tapes: Array<{ name: string, x: number, y: number }>,
        tapeMeshes: Mesh[]) {
        const tapesToPersist = this.getTypesToPersist(backs, tapes);
        tapeMeshes.forEach((x) => {
            const visibility = tapesToPersist.some((y) => x.name.includes(y.name)) ? 1 : 0;
            x.visibility = visibility;
        });
    }

    private getTypesToPersist(
        backs: Element[],
        tapes: Array<{ name: string, x: number, y: number }>,
    ) {
        return tapes.filter((tape) =>
            backs.some((back) => {
                const corner = {
                    x: back.position.x - back.shape.x / 2,
                    y: back.position.y + back.shape.y / 2,
                };
                return (
                    tape.x > corner.x &&
                    tape.x < corner.x + back.shape.x &&
                    tape.y < corner.y &&
                    tape.y > corner.y - back.shape.y
                );
            }),
        );
    }
}
